import gql from 'graphql-tag'

export const FILE = gql`
  fragment File on File {
    id
    path
    name
    extension
    mimetype
    created_at
    status
  }
`
export const UPLOAD_PUBLIC_FILE = gql`
  fragment UploadPublicFile on File {
    id
    path
    name
    extension
    mimetype
    status
    presignedPost(acl: "public-read")
  }
`

export const UPLOAD_PRIVATE_FILE = gql`
  fragment UploadPrivateFile on File {
    id
    path
    name
    extension
    mimetype
    status
    presignedPost(acl: "private")
  }
`
